/* Virgoish polish: gentle in-frame image parallax + soft scroll reveals. */
(function () {
  if (window.__vbPolish) return;
  window.__vbPolish = true;
  var CORNER_SEL = '.cstm-fp__media, .cstm-innov__media, .cstm-innov2__media, .cstm-story__media, .vb-life__media, .shopify-section [class*="image-block--"]';
  function corners() {
    var mid = document.documentElement.clientWidth / 2;
    document.querySelectorAll(CORNER_SEL).forEach(function (el) {
      var r = el.getBoundingClientRect();
      el.classList.toggle('vb-corner--r', r.width > 0 && r.left + r.width / 2 > mid + 40);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', corners); else corners();
  window.addEventListener('resize', corners);
  document.addEventListener('shopify:section:load', corners);

  /* FAQ accordions: all closed on load, and only one open at a time per section. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cstm-faq__question');
    if (!btn || btn.dataset.vbAuto) return;
    setTimeout(function () {
      if (btn.getAttribute('aria-expanded') !== 'true') return;
      var root = btn.closest('.shopify-section') || document;
      root.querySelectorAll('.cstm-faq__question[aria-expanded="true"]').forEach(function (other) {
        if (other === btn) return;
        other.dataset.vbAuto = '1';
        other.click();
        delete other.dataset.vbAuto;
      });
    }, 0);
  });
  function closeFaqs() {
    document.querySelectorAll('.cstm-faq__question[aria-expanded="true"]').forEach(function (b) {
      b.dataset.vbAuto = '1';
      b.click();
      delete b.dataset.vbAuto;
    });
  }
  if (document.readyState === 'complete') closeFaqs(); else window.addEventListener('load', closeFaqs);

  /* Silver shimmer: tag sections whose background is a neutral light grey. */
  function silver() {
    var main = document.querySelector('main');
    if (!main) return;
    Array.prototype.forEach.call(main.children, function (sec) {
      if (!sec.classList.contains('shopify-section')) return;
      [sec, sec.querySelector(':scope > .section-background, :scope > * > .section-background'), Array.prototype.find.call(sec.children, function (c) { return c.offsetHeight > 0; })].some(function (el) {
        if (!el || el.offsetHeight === 0) return false;
        var m = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
        if (!m || (m.length > 3 && +m[3] < 0.5)) return false;
        var r = +m[0], g = +m[1], b = +m[2];
        var lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        var neutral = Math.max(r, g, b) - Math.min(r, g, b) <= 6;
        if (neutral && lum > 0.88 && lum < 0.985 &&
            getComputedStyle(el, '::before').content === 'none' &&
            getComputedStyle(el, '::after').content === 'none') {
          if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
          el.classList.add('vb-silver');
        }
        return true; /* stop at the first element that has a background */
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', silver); else silver();

  /* Dotted curvy "thread" linking sections. */
  function isDark(sec) {
    var els = [sec, sec.firstElementChild];
    for (var k = 0; k < els.length; k++) {
      if (!els[k]) continue;
      var m = getComputedStyle(els[k]).backgroundColor.match(/[\d.]+/g);
      if (m && (m.length < 4 || +m[3] > 0.5)) {
        return (0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2]) / 255 < 0.6;
      }
    }
    return false;
  }
  function threads() {
    var main = document.querySelector('main[data-template^="product"], main[data-template="index"], main[data-template="page.about"]');
    if (!main || main.querySelector('.vb-thread')) return;
    var secs = Array.prototype.filter.call(main.children, function (s) {
      return s.classList.contains('shopify-section') && s.offsetHeight > 0 && !/recommendation/.test(s.id);
    });
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    for (var i = 1; i < secs.length; i++) {
      /* No thread directly under a hero: it would sit on top of imagery. */
      if (secs[i - 1].querySelector('.vb-hero, .cstm-abouthero__bg, .cstm-hero')) continue;
      var t = document.createElement('div');
      t.className = 'vb-thread' + (i % 2 ? '' : ' vb-thread--flip') + (still ? ' is-in' : '') +
        (isDark(secs[i - 1]) || isDark(secs[i]) ? ' vb-thread--soft' : '');
      t.setAttribute('aria-hidden', 'true');
      t.innerHTML =
        '<svg viewBox="0 0 120 150" focusable="false">' +
        '<circle class="vb-thread__dot" cx="34" cy="6" r="3.5"/>' +
        '<path class="vb-thread__line" d="M34 6 C 34 52, 92 46, 90 84 C 88 118, 58 120, 60 136"/>' +
        '<path class="vb-thread__spark" d="M60 128 Q61 135 68 136 Q61 137 60 144 Q59 137 52 136 Q59 135 60 128 Z"/>' +
        '</svg>';
      secs[i].parentNode.insertBefore(t, secs[i]);
    }
    if (still || !('IntersectionObserver' in window)) {
      main.querySelectorAll('.vb-thread').forEach(function (t) { t.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -15% 0px' });
    main.querySelectorAll('.vb-thread').forEach(function (t) { io.observe(t); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', threads); else threads();

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var PX_SEL = [
    '.cstm-fp__media',
    '.cstm-innov__media',
    '.cstm-innov2__media',
    '.cstm-story__media',
    '.vb-life__media',
    '.shopify-section [class*="image-block--"]'
  ].join(',');
  var RV_SEL = '.vb-ingr__card, .vb-life__copy';
  var STRENGTH = 0.05; /* max drift as a share of frame height */

  var style = document.createElement('style');
  style.textContent =
    '.vb-px{overflow:hidden}' +
    '.vb-px>img,.vb-px>video,.vb-px>picture>img{transform:translate3d(0,var(--vb-px,0px),0) scale(1.12);transform-origin:center;will-change:transform}' +
    '.vb-rv{opacity:0;transform:translate3d(0,22px,0);transition:opacity .9s cubic-bezier(.2,.7,.2,1),transform .9s cubic-bezier(.2,.7,.2,1)}' +
    '.vb-rv.is-in{opacity:1;transform:none}';
  document.head.appendChild(style);

  var active = new Set();
  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    active.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      if (p < -1) p = -1;
      if (p > 1) p = 1;
      el.style.setProperty('--vb-px', (-p * r.height * STRENGTH).toFixed(1) + 'px');
    });
  }
  function request() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }

  var pxIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) active.add(e.target); else active.delete(e.target);
    });
    request();
  }, { rootMargin: '100px 0px' });

  var rvIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); rvIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' });

  function scan(root) {
    (root || document).querySelectorAll(PX_SEL).forEach(function (el) {
      if (el.dataset.vbPx || el.closest('media-gallery, .vb-hero, header, footer')) return;
      if (!el.querySelector(':scope > img, :scope > video, :scope > picture > img')) return;
      el.dataset.vbPx = '1';
      el.classList.add('vb-px');
      pxIO.observe(el);
    });
    var vh = window.innerHeight;
    (root || document).querySelectorAll(RV_SEL).forEach(function (el, i) {
      if (el.dataset.vbRv) return;
      el.dataset.vbRv = '1';
      if (el.getBoundingClientRect().top < vh * 0.92) return; /* already on screen: leave as is */
      el.classList.add('vb-rv');
      if (el.classList.contains('vb-ingr__card')) {
        var idx = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.style.transitionDelay = (idx % 3) * 90 + 'ms';
      }
      rvIO.observe(el);
    });
    request();
  }

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
})();
